// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "resource/add-pages/js/" + chunkId + "." + {"283":"e49de233","831":"0ef6228c"}[chunkId] + ".js";
};